import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  CircularProgress,
  Typography,
} from "@material-ui/core";

import { useStore } from "@store/store";
import closeIcon from "@assets/images/close.svg";
import { PermissionPopup } from "./style";
import PermissionTableListing from "../permission-table-listing";

function PopupPermission(props) {
  const classes = PermissionPopup();
  const [scroll] = useState("body");
  const [state] = useStore();
  const [isOpenPermissionInfo, setIsOpenPermissionInfo] = useState(false);

  /**
   * We use decimal to decide action of a permission
   * 000 (0 in decimal) is no permission
   * 001 (1 in decimal) is "read only" permission
   * 010 (2 in decimal) is "write" permission
   * 100 (4 in decimal) is "delete" permission
   * 111 (7 in decimal) is "read" + "write" + "delete" permission
   * 011 (3 in decimal) is "read" + "write" permission
   * 101 (5 in decimal) is "read" + "delete" permission
   * 110 (6 in decimal) is "write" + "delete" permission
   */

  // Move Item "CargoWise Jobs Update" next to item "Jobs" in menuData list.
  let menuData = props?.menuData;
  if (menuData) {
    let indexJob = menuData.findIndex(item => item.label === "Jobs");
    let indexCargoWiseJob = menuData.findIndex(item => item.label === "CargoWise")
    let cargoWiseJobObj = menuData[indexCargoWiseJob];
    menuData.splice(indexCargoWiseJob, 1);
    menuData.splice(indexJob + 1, 0, cargoWiseJobObj);
  }

  return (
    <Dialog
      open={props.open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={classes.customModal}
      scroll={scroll}
    >
      <div className="close-modal">
        <img src={closeIcon} alt="Close" onClick={props.handleClose} />
      </div>
      <form noValidate autoComplete="off" className={classes.customForm}>
        <DialogTitle id="alert-dialog-title">Permission</DialogTitle>
        <DialogContent>
          <div className="form-row">
            <div className="form-gourp full-width">
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="permission">Select Permission</InputLabel>
                <Typography
                  variant="body2"
                  className="permission-info"
                  onClick={(event) => {
                    setIsOpenPermissionInfo(true);
                  }}
                >
                  {props?.name || "None Permission"}
                </Typography>
              </FormControl>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="bottom-button-block">
          <Button
            className="primary-btn gray-border-btn"
            color="inherit"
            disableElevation
            underlinenone="true"
            onClick={props.handleClose}
            type="reset"
          >
            CANCEL
          </Button>
          <Button
            className="orange-btn primary-btn"
            color="inherit"
            disableElevation
            underlinenone="true"
            type="button"
            onClick={props.assignPermission}
            disabled={state.rolesPermission.settingRolesPermission}
          >
            {state.rolesPermission.settingRolesPermission ? (
              <CircularProgress color="inherit" />
            ) : (
              "Assign"
            )}
          </Button>
        </DialogActions>
      </form>
      <PermissionTableListing
        open={isOpenPermissionInfo}
        handleClose={() => setIsOpenPermissionInfo(false)}
        listPermission={props?.menuData}
        permissionInfoData={props.permissionInfoData}
        handleChange={props.handleChange}
      />
    </Dialog>
  );
}

export default PopupPermission;
